var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRedWall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#FEF2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 33.6666C45.3334 41.9999 39.5 46.1666 32.5667 48.5833C32.2036 48.7063 31.8092 48.7004 31.45 48.5666C24.5 46.1666 18.6667 41.9999 18.6667 33.6666V21.9999C18.6667 21.5579 18.8423 21.134 19.1548 20.8214C19.4674 20.5089 19.8913 20.3333 20.3334 20.3333C23.6667 20.3333 27.8334 18.3333 30.7334 15.7999C31.0864 15.4983 31.5356 15.3325 32 15.3325C32.4644 15.3325 32.9136 15.4983 33.2667 15.7999C36.1834 18.3499 40.3334 20.3333 43.6667 20.3333C44.1087 20.3333 44.5326 20.5089 44.8452 20.8214C45.1578 21.134 45.3334 21.5579 45.3334 21.9999V33.6666Z",
    stroke: "#E7000B",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25.3335V32.0002",
    stroke: "#E7000B",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 38.6665H32.0167",
    stroke: "#E7000B",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRedWall);
export default __webpack_public_path__ + "static/media/ic_red_wall.1cf2d7e78494efc045a118abd5a9e879.svg";
export { ForwardRef as ReactComponent };